/**
 *  30/05/2020 v 1.0 - JuanMa
 *
 * v.1.1 04/06/2020 Añadido para CELLTIPO_COMBO
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  11/12/2023 En Props cambiado de OnAceptado a onAceptado
 *                   En la llamada a <SelectorOpciones oñadidos:  campoTexto={columna.campoTexto} y   campoClave={columna.campoClave}
 **/

import React from 'react'
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import * as Classes from "@blueprintjs/core/lib/esm/common/classes";
import {Button, Dialog, Intent, Tooltip} from "@blueprintjs/core";
import DateTimeInput from "../../blueprint/DateTimeInput";
import {CELLTIPO_COLOR, CELLTIPO_FECHA, CELLTIPO_FECHAHORA,CELLTIPO_COMBO} from "./TiposCeldas";
import ColorPicker from "../../color/ColorPicker";
import SelectorOpciones from "./SelectorOpciones";

class DialogoSelector extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            opened: props.opened,
            tipo: props.tipo,
            selectedRow: props.selectedRow,
            columna: props.columna,
            valor: props.selectedRow && props.columna ? props.selectedRow[props.columna.campo] : null,
        }
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.opened !== prevState.opened) {
            newState.opened = nextProps.opened;
        }
        if (nextProps.tipo !== prevState.tipo) {
            newState.tipo = nextProps.tipo;
        }
        if (nextProps.selectedRow !== prevState.selectedRow) {
            newState.selectedRow = nextProps.selectedRow;
        }
        if (nextProps.columna !== prevState.columna) {
            newState.columna = nextProps.columna;
        }

        if (nextProps.selectedRow && nextProps.columna) {
            newState.valor = nextProps.selectedRow[nextProps.columna.campo];
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onCancelar= () => {
        const {onCancelado} = this.props;
        onCancelado && onCancelado();
    }

    onAceptar= () => {
        const {valor} =  this.state;
        const {onAceptado} = this.props;
        //console.log("DIALOGOSELECTOR - ONACEPTAR");
        //console.log("valor: ", valor);

        onAceptado && onAceptado(valor);
    }


    getSelector= () => {
        const {columna, valor} =  this.state;
        if (columna) {
            switch (columna.tipo) {
                case CELLTIPO_FECHA:
                    return (<DateTimeInput conHora={false}
                                           valor={valor}
                                           obligatorio={true}
                                           onChange={(datetime) => this.setState({valor: datetime})}
                    />);

                case CELLTIPO_FECHAHORA:
                    return (<DateTimeInput conHora={true}
                                           valor={valor}
                                           obligatorio={true}
                                           onChange={(datetime) => this.setState({valor: datetime})}
                    />);
                case CELLTIPO_COLOR:
                    return (<ColorPicker
                        color={valor}
                        onChange={(color) => this.setState({valor: color})}
                    />);

                case CELLTIPO_COMBO:
                    return ( <SelectorOpciones opciones= {columna.valores}
                                               valor={valor}
                                               campoTexto={columna.campoTexto}
                                               campoClave={columna.campoClave}
                                               onValueChanged={(valor) => {
                                                   console.log("Opcion seleccionada: ", valor);
                                                   this.setState({valor: valor})}   }
                    />);

            }
        }
    }


    render() {
        const {opened, columna} =  this.state;
        return (
            <div>
                <Dialog
                    icon="info-sign"
                    onClose={this.onCancelar}
                    title= { columna ? columna.titulo: ""}
                    isOpen={opened}
                    usePortal= {true}
                    canOutsideClickClose={false}
                    style={{ width: "30%"}}
                    autofocus={true}
                >
                    <div className={Classes.DIALOG_BODY} style={{height:100}}>
                        {this.getSelector()}
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Tooltip content="Aceptar">
                                <Button intent={Intent.SUCCESS} icon="tick-circle" onClick={this.onAceptar}>Aceptar</Button>
                            </Tooltip>
                            <Tooltip content="Cancelar">
                                <Button intent={Intent.DANGER} icon="delete" onClick={this.onCancelar}>Cancelar</Button>
                            </Tooltip>
                        </div>
                    </div>
                </Dialog>
            </div>



        );
    }
}


DialogoSelector.propTypes = {

    opened: PropTypes.bool,
    selectedRow: PropTypes.object,
    columna: PropTypes.object,
    onCancelado: PropTypes.func,
    onAceptado: PropTypes.func,
}

export default DialogoSelector

